import React, { Component } from "react";
import { shape, node, string } from "prop-types";

import * as i18nUtils from "util/i18n";

import CreditCardsListItem from "pages/creditCards/ListItem";
import WidgetList from "pages/desktop/widgets/WidgetList";
import WidgetHeader from "./_components/WidgetHeader";

class CreditCards extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        goTo: string,
    };

    static defaultProps = {
        closeButton: null,
        goTo: "",
    };

    render() {
        const uiAutomationProp = { "data-ui-automation": "widgetCreditCards" };

        const { closeButton, draggableItemProps, goTo } = this.props;

        return (
            <WidgetList item={CreditCardsListItem} keyExtractor={(item) => item.idProduct} name="creditCards">
                {(list) => (
                    <section
                        role="button"
                        className="widget"
                        {...uiAutomationProp}
                        {...draggableItemProps}
                        aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                        <WidgetHeader title={i18nUtils.get("menu.creditcards")} action={closeButton} goTo={goTo} />
                        {list}
                        <div className="overlay" />
                    </section>
                )}
            </WidgetList>
        );
    }
}

export default CreditCards;
